import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CartDrawer } from './components/CartDrawer';
import { Home } from './pages/Home';
import { Shop } from './pages/Shop';
import { ProductDetail } from './pages/ProductDetail';
import { Contact } from './pages/Contact';
export function App() {
  return <CartProvider data-id="element-0">
      <div className="min-h-screen bg-brand-cream font-sans text-brand-dark selection:bg-brand-orange selection:text-white flex flex-col" data-id="element-1">
        <Header data-id="element-2" />

        <div className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/shop" element={<Shop data-id="element-8" />} data-id="element-7" />
            <Route path="/product/:slug" element={<ProductDetail data-id="element-10" />} data-id="element-9" />
            <Route path="/contact" element={<Contact data-id="element-12" />} data-id="element-11" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-14" />} data-id="element-13" />
          </Routes>
        </div>

        <Footer data-id="element-15" />

        <CartDrawer data-id="element-16" />
      </div>
    </CartProvider>;
}